<script lang="ts">
  export let tag;

  function stringToColor(input) {
    const str = input.tag;
    if (!str) {
      return "#ffffff";
    }
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    var colour = "#";
    for (var i = 0; i < 3; i++) {
      var value = (hash >> (i * 8)) & 0xff;
      colour += ("00" + value.toString(16)).substr(-2);
    }
    return colour;
  }
</script>

<button
  on:click
  class="tag"
  style="border-color: {stringToColor({ tag })}; color: {stringToColor({
    tag,
  })};"
>
  {tag}
</button>

<style>
  :global(.tag) {
    cursor: pointer;
    margin-right: 0.5rem;
    font-size: 0.75rem;
    border-radius: 4px;
    border: 1px solid #ccc;
    padding: 0.25rem 0.5rem;
  }
</style>
